import React, { Component } from 'react';
import { Feed, Item, Button, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import './EntryGroup.css';

class EntryGroup extends Component {
  state = {
    allSelected: false,
    columns: 1
  }

  brakePoints = [ 800, 1200, 1400, 1600 ]

  static propTypes = {
    header: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.object),
    handleSelectAll: PropTypes.func,
    handleUnselectAll: PropTypes.func,
    toggleSelected: PropTypes.func,
    isSelected: PropTypes.bool
  }

  static defaultProps = {
    header: ''
  }

  onResize() {
    if (!this.container) return;
    const columns = this.getColumns(this.container.offsetWidth);
    if(columns !== this.state.columns){
      this.setState({columns: columns});
    }
  }

  getColumns(width){
    return this.brakePoints.reduceRight((numCols, bp, i) => {
      return bp < width ? numCols : i + 1;
    }, this.brakePoints.length);
  }

  getContainerRef = (ref) => {
    this.container = ref;
    window.addEventListener('resize', (e) => {
      this.onResize();
    })
    this.onResize();
  }

  render() {
    const { isSelected, toggleSelected, className } = this.props;
    const iconName = isSelected ? 'flatico-add-2' : 'edit';
    const showButtons = this.props.children.length > 1;
    return (
      <Feed.Event className={`entry-group-container ${className}`}>
        <Feed.Label>
          <div className="header">
            {this.props.header}
          </div>
        </Feed.Label>
        <Button.Group basic>
          <Button onClick={() => toggleSelected(!isSelected)}>
            { showButtons && <Icon className={iconName}/> }
          </Button>
          <Button icon={ showButtons && 'external'} onClick={this.props.openAll}/>
        </Button.Group>
        <Feed.Content className={`columns-${this.state.columns}`}>
          <div ref={this.getContainerRef}>
            <Item.Group unstackable className={`item-group`}>
              {this.props.children}
            </Item.Group>
          </div>
        </Feed.Content>
      </Feed.Event>
    )
  }
}

export default EntryGroup;



// WEBPACK FOOTER //
// ./src/components/EntryGroup/index.js